import { TERMS_AND_CONDITIONS, PRIVACY_POLICY } from 'routes/external'

import { InputPassword } from '~shared'
import { Input, Typography, Link, Checkbox } from '~ui'

import styles from './SignUp.module.scss'

const { Text } = Typography

const SignUpFormComponent = ({
  values,
  errors,
  status,
  touched,
  loading,
  handleBlur,
  handleSubmit,
  handleChange,
}) => (
  <form onSubmit={handleSubmit}>
    <div className={styles['input-columns']}>
      <Input
        type="text"
        id="firstName"
        name="firstName"
        autoComplete="given-name"
        onBlur={handleBlur}
        onChange={handleChange}
        value={values.firstName}
        error={touched.firstName && errors.firstName}
        placeholder="First name"
      />

      <Input
        type="text"
        id="lastName"
        name="lastName"
        autoComplete="family-name"
        onBlur={handleBlur}
        value={values.lastName}
        onChange={handleChange}
        error={touched.lastName && errors.lastName}
        placeholder="Last name"
      />
    </div>

    <Input
      id="email"
      name="email"
      type="email"
      autoComplete="email"
      onBlur={handleBlur}
      value={values.email}
      onChange={handleChange}
      error={touched.email && errors.email}
      placeholder="Email Address"
    />

    <InputPassword
      onBlur={handleBlur}
      autoComplete="new-password"
      value={values.password}
      onChange={handleChange}
      error={touched.password && errors.password}
    />

    <div className={styles['terms-checkbox']}>
      <Checkbox
        name="terms"
        value="terms"
        onBlur={handleBlur}
        checked={values.terms}
        onChange={handleChange}
        label={
          <Text size="sm">
            By signing up you agree to Granted&apos;s{' '}
            <Link href={TERMS_AND_CONDITIONS} color="green" target="_blank" size="sm">
              Terms of Service
            </Link>
            {' and '}
            <Link href={PRIVACY_POLICY} color="green" target="_blank" size="sm">
              Privacy Policy
            </Link>
            .
          </Text>
        }
      />
    </div>

    {touched.terms && errors.terms && (
      <Text color="red">You must accept the Terms and Conditions</Text>
    )}

    {!!status && (
      <Text color="red" center>
        {status}
      </Text>
    )}

    <button className="btn w-full btn-primary" disabled={loading} type="submit">
      Sign Up
    </button>
  </form>
)

export default SignUpFormComponent
